import storage from 'redux-persist/lib/storage'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers} from 'redux';
import ProductReducer from './reducers/ProductReducer';
import cartReducer  from './reducers/SelectedProductReducer';
import BarController from './reducers/BarController';
import SaveCredentialsReducer from './reducers/SaveUserCredentials';
import WalletReducer from './reducers/WalletReducer';
import FarmerInfoReducer from './reducers/FarmerInfoReducer';
import selectedWalletReducer from './reducers/selectedWalletReducer'
import selectedWalletMoreInfoReducer from "./reducers/selectedWalletMoreInfoReducer";
import serviceTypeReducer from "./reducers/ServiceTypeReducer";
import DashboardFilters from './reducers/DashboardFilters';

const rootPersistConfig = {
    key: 'root',
    storage: storage,
   
}

const rootReducer = combineReducers({
    products:ProductReducer,
    cart: cartReducer,
    bar_controller:BarController,
    userCredentials:SaveCredentialsReducer,
    wallets: WalletReducer,
    farmer: FarmerInfoReducer,
    wallet_info : selectedWalletReducer,
    wallet_more_info : selectedWalletMoreInfoReducer,
    service_selector: serviceTypeReducer,
    dashboardFilters: DashboardFilters
})


const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});


export default store;
